import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { useSelector } from 'react-redux';
import { asymChartMapper } from '../../mappers/model/AsymChartMapper'; 

const AsymChartExample = ({ 
  data, metric, stat, showTitle = true, enableDrillDown = false, position = [], 
  playerGroup = [], session = [], playerId = null }) => {
  const {
    info: {
      team_colors: teamColors,
    },
  } = useSelector(({ team }) => team);
  const options = React.useMemo(() => {
    return asymChartMapper(data, metric, teamColors, stat, showTitle, true, enableDrillDown, session, 
      playerGroup, position, playerId);
  }, [data, metric, teamColors, stat]);

  
  if (!options) {
    return null; 
  }

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={{...options, chart: {...options.chart, height: '100%'}}}
    />
  );
};

export default AsymChartExample;